/** Route `currentView` values that belong to the left-rail Network item. */
export const NETWORK_NAV_VIEWS = new Set([
  "facility-network",
  "facility-network-gate",
  "facility-network-declare-parent",
  "facility-network-add-children",
  "facility-network-review-request",
  "facility-network-review-unlink-request",
  "parentFacility",
  "network",
  "network-facility",
  "network-intelligence",
]);

export type NetworkPathDestination = {
  view:
    | "facility-network"
    | "facility-network-gate"
    | "network-intelligence";
  networkTab?: "overview";
};

function trimPath(pathname: string): string {
  return pathname.replace(/\/+$/, "") || "/";
}

function normalizeDashboardPath(pathname: string): string {
  const trimmed = trimPath(pathname);
  if (trimmed === "/network" || trimmed.startsWith("/network/")) {
    return `/dashboard${trimmed}`;
  }
  if (trimmed === "/intel" || trimmed.startsWith("/intel/")) {
    return `/dashboard/network${trimmed}`;
  }
  return trimmed;
}

export function isNetworkIntelligencePath(pathname: string): boolean {
  const path = normalizeDashboardPath(pathname);
  return (
    path === "/dashboard/network/intel" ||
    path.startsWith("/dashboard/network/intel/") ||
    path === "/dashboard/intel" ||
    path.startsWith("/dashboard/intel/")
  );
}

export function isMyNetworkPath(pathname: string): boolean {
  const path = normalizeDashboardPath(pathname);
  if (isNetworkIntelligencePath(path)) return false;
  return path === "/dashboard/network" || path.startsWith("/dashboard/network/");
}

/** Map `/dashboard/network` and `/dashboard/network/intel` (plus legacy aliases) to Spaces views. */
export function resolveNetworkDestinationFromPath(
  pathname: string,
): NetworkPathDestination | null {
  const path = normalizeDashboardPath(pathname);
  if (
    path === "/dashboard/network/intel/gate" ||
    path === "/dashboard/intel/gate"
  ) {
    return { view: "network-intelligence" };
  }
  if (isNetworkIntelligencePath(path)) {
    return { view: "network-intelligence" };
  }
  if (path === "/dashboard/network/gate") {
    return { view: "facility-network-gate" };
  }
  if (isMyNetworkPath(path)) {
    return { view: "facility-network", networkTab: "overview" };
  }
  return null;
}

/** Map URL segment + Spaces `currentView` to SpacesNavigation `activeNavItem`. */
export function resolveDashboardNavItem(
  pathSegment: string | undefined,
  currentView?: string,
  pathname?: string,
): string {
  if (currentView && NETWORK_NAV_VIEWS.has(currentView)) {
    return "network";
  }
  if (pathname && resolveNetworkDestinationFromPath(pathname)) {
    return "network";
  }
  if (pathSegment === "network" || pathSegment === "intel") {
    return "network";
  }
  if (pathSegment === "facilities") {
    return "spaces";
  }
  return pathSegment || "spaces";
}
